import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';
import { ActionBarPortalService } from '@core/services/common/action-bar-portal.service';

@Directive({
  selector: '[appActionBarPortal]',
})
export class ActionBarPortalDirective implements OnInit, OnDestroy {
  @Input() forceLayoutClass = false;
  private portal: TemplatePortal<unknown> | null = null;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    private actionBarPortalService: ActionBarPortalService,
  ) {}

  ngOnInit(): void {
    this.portal = new TemplatePortal(this.templateRef, this.viewContainerRef);
    this.actionBarPortalService.registerPortal(this.portal, this.forceLayoutClass);
  }

  ngOnDestroy(): void {
    if (this.portal) {
      this.actionBarPortalService.unregisterPortal(this.portal);
      this.portal = null;
    }
  }
}
